import React from 'react';
import NavBar from '../../components/navbar/navBarComponent';
import Breadcrumb from '../../components/breadcrumb/breadcrumbComponent';
import DiscountForm from '../../components/discount-form/discountForm';

const DiscountCreatePage = (props) => {
  const breadcrumbItems = [
    { name: 'Menu', link: '/menu' },
    { name: 'Descuentos', link: '/discounts' },
    { name: 'Crear', link: '/discounts-create' },
  ];

  return (
    <div id="main-discount-create" className="container-fluid page">
      <NavBar cart={props.cart} isLogIn={props.isLogIn} />
      <Breadcrumb page="discounts-admin-create" items={breadcrumbItems} />
      <DiscountForm />
    </div>
  );
};

export default DiscountCreatePage;